import { render, staticRenderFns } from "./TargetDialog.vue?vue&type=template&id=278e24a9"
import script from "./TargetDialog.vue?vue&type=script&lang=ts"
export * from "./TargetDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports